import { DEFAULT_PAGE } from "@app/constants";
import { CreateImageRequest, Image, ImageResponse } from "@app/types";
import HttpService from "@core/services/http/http.service";
import { HttpOptions } from "@core/services/http/http.type";

class _ImageService {
  public getImage(page = DEFAULT_PAGE, isBooting?: boolean) {
    return HttpService.get<ImageResponse>("/images", {
      queryParams: {
        page,
        // chỉ lấy máy đang boot (hiện "Đang khởi tạo" ở Máy đang thuê)
        is_booting: isBooting ? 1 : undefined,
      },
    });
  }

  public createImage(createImageRequest: CreateImageRequest) {
    return HttpService.post<Image>("/images", {
      body: {
        ...createImageRequest,
      },
    });
  }

  public deleteImage(imageId: string, options?: HttpOptions) {
    return HttpService.delete<Image>(`/images/${imageId}`, options);
  }

  public wol(imageId: string) {
    return HttpService.get<Image>(`/images/wol/${imageId}`);
  }

  public reConnect(imageId: string) {
    return HttpService.get<any>(`/images/reconnect/${imageId}`);
  }
}

const ImageService = new _ImageService();

export default ImageService;
